// extracted by mini-css-extract-plugin
export default {"label":"EditUserRoleModal_label__UnR1M","para":"EditUserRoleModal_para__6k+-L","forgetPassword":"EditUserRoleModal_forgetPassword__rWqh3"};